function debounce(callback, delayMs) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => callback(...args), delayMs);
  };
}

export { debounce };
//# sourceMappingURL=debounce.js.map
